import 'babel-polyfill'
import Vue from 'vue'
import router from './router'
import App from './App.vue'
import config from './config'
import './assets/scss/main.scss'
import store from '../src/store/index'
import apolloProvider from './plugins/apollo'

Vue.config.productionTip = false

async function init () {
  for (let pluginName of config.plugins) {
    let plugin = require('./plugins/' + pluginName)
    if (plugin && plugin.default && typeof plugin.default === 'function') {
      await plugin.default()
    }
  }
  new Vue({
    router,
    store,
    apolloProvider,
    render: h => h(App)
  }).$mount('#app')
}
init()
